import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
// import { InputContainer } from ".../../MoveOut.styled";
import cc from "../../assets/ccIcon.svg";
import { Label } from "../../screens/complaint/Complaint.styled";
import cvv from "../../assets/cvv.svg";
import CloseIcon from "../../assets/CloseIcon.svg";
import ThanksIcon from "../../assets/thanks.svg";
import styled from "styled-components";

import OtpInput from "react18-input-otp";

import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import { Contrast } from "@mui/icons-material";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";

const InputContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: #edf4f6;
    border: 1px solid #b6bfdc;
    margin: 0 0.5rem;
  }
`;

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  //   onVerify:any,
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;
  delData: () => void;
  loader?: Boolean;
}

const DelModal = ({ onClose, delData,loader }: Props) => {
  //   useEffect(()=>{
  //     General.sendOTP({errorId: 'sendOTPError', data: {premiseId:null, email, mobile, personID}})
  //   },[])

  return (
    <div style={{ width:General?.isLargeScreen? "50%":'100%', overflow: "auto", margin: "30vh auto" ,direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",}}>
      <div
        style={{
          width: "100%",
          justifyContent: "space-between",
          padding:'1rem',
          background:  General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General.ColorAss,
          display: "flex",
          alignItems: "center",
        }}
      >
        <h1  style={{ color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff", justifySelf: "flex-start",fontSize:`${2*General.accessibility.fontSize}rem` }}>
        {General?.codeLabels["cm_del_card"]?.label !== undefined ? General?.codeLabels["cm_del_card"]?.label : "DELETE"}
        </h1>
        <img src={CloseIcon} alt="" onClick={onClose} />
      </div>
<TabContainer style={{
          padding: "3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}>

   {General?.codeLabels["cm_del_confrm"]?.label !== undefined ? General?.codeLabels["cm_del_confrm"]?.label : "DELETE"}
</TabContainer>

      <TabContainer
        style={{
          padding: "0.3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}
      >

        <ButtonsContainer
          style={{ display: "flex", gap: "12px", width: "fit-content", paddingBottom: "1rem" }}
        >
          <ButtonSecondary
            style={{ 
              width: "45%", 
              padding: "auto",
              fontSize:`${General.accessibility.fontSize}rem`,
              color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              background: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "white",
              borderColor: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
            }}
            onClick={onClose}
          >
            {General?.codeLabels["cm_usepassloginpagecancel"]?.label !== undefined ? General?.codeLabels["cm_usepassloginpagecancel"]?.label : "CANCEL"}

          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: "45%",
              padding: "auto",
              color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground:"#fff",
              background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor :General?.ColorAss,
              border:"none",
              whiteSpace: "nowrap",fontSize:`${General.accessibility.fontSize}rem`
            }}
            onClick={delData}
          >
            {loader?    <Spinner width="30px" height="30px"/>:General?.codeLabels["cm_delete"]?.label !== undefined ? General?.codeLabels["cm_delete"]?.label : "DELETE"}
         </ButtonSecondary>
        </ButtonsContainer>
      </TabContainer>
    </div>
  );
};

export default observer(DelModal);
